import ENV from 'react-native-config';

import Axios from 'axios';

import { isWeb } from 'utils/responsiveness';

export type ConsentOrderingResponseData = { consent_ordering: string[] };

async function getConsentsData(): Promise<
    ConsentOrderingResponseData | { consent_ordering: undefined }
> {
    try {
        const { data } = await Axios.get<ConsentOrderingResponseData>(
            `https://client.onetv-prod.one.hu/consents/${
                // isWeb ? ENV.DIDOMI_WEB_NOTICE_ID : ENV.DIDOMI_MOBILE_NOTICE_ID
                // ! Mocked DIDOMI_WEB_NOTICE_ID and DIDOMI_MOBILE_NOTICE_ID for testing
                isWeb ? '449gfQYH' : 'Tb2VZBDF'
            }.json`,
        );

        return data;
    } catch (error) {
        return { consent_ordering: undefined };
    }
}

export default getConsentsData;
